/* global axios */
import ApiClient from './ApiClient';
import store from '../store';

class OffersAPI extends ApiClient {
    constructor() {
        super('offers', { accountScoped: true });
    }

    get accountId() {
        return store.state.auth.currentUser.account_id;
    }

    async getOffers(page = 1) {
        const params = {
            page: page > 1 ? page : undefined,
        };

        // Remover parâmetros undefined
        Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

        return axios.get(this.url, { params });
    }

    async getOffer(offerId) {
        const response = await axios.get(`${this.url}/${offerId}`);
        return response;
    }

    async createOffer(data) {
        let payload;
        if (data instanceof FormData) {
            payload = data;
        } else {
            payload = { offer: data };
        }
        const response = await axios.post(this.url, payload);
        return response;
    }

    async updateOffer(offerId, data) {
        let payload;
        if (data instanceof FormData) {
            payload = data;
        } else {
            payload = { offer: data };
        }
        const response = await axios.put(`${this.url}/${offerId}`, payload);
        return response;
    }

    async deleteOffer(offerId) {
        const response = await axios.delete(`${this.url}/${offerId}`);
        return response;
    }

    async searchOffers(query) {
        const params = {
            query: query,
        };

        const response = await axios.get(`${this.url}/search`, { params });
        return response;
    }
}

export default new OffersAPI();
